import React, { useMemo } from 'react'

import { Caption, Marquee } from 'ui/bend'
import { useMusicContext } from './MusicPlayerContext'

const MusicMarquee = ({ skipError }) => {
  const { currentSong, handleHideMarquee } = useMusicContext()

  // useMemo is here so we don't recalculate the desired ticker width/speed on every MusicContext() update, even ones unrelated to currentSong.
  // We don't want to add handleHideMarquee, because that will trigger a re-render (and thus interrupt our animation) when handleHideMarquee gets recreated
  return useMemo(
    () => (
      <Marquee callback={handleHideMarquee} callbackTimeout={4000} width={192}>
        <Caption color='grey5' mt='8px' whiteSpace='nowrap'>
          {skipError
            ? 'Skip Max Reached'
            : currentSong || 'Play music during class'}
        </Caption>
      </Marquee>
    ),
    [currentSong, skipError]
  )
}

export default MusicMarquee
